<template>
    <div class="car-model">
        
        <header>
            <div class="main">
                <img loading="lazy" :class="{active: hoverBrand=='tiggo'}" @mouseenter="bindCurrentModel('tiggo'); hoverBrand='tiggo'" src="../../assets/logos/tiggo.png" alt="tiggo logo">
                <img loading="lazy" :class="{active: hoverBrand=='arrizo'}" @mouseenter="bindCurrentModel('arrizo'); hoverBrand='arrizo'" src="../../assets/logos/arrizo.png" alt="arrizo logo">
                <img loading="lazy" :class="{active: hoverBrand=='himla'}" @mouseenter="bindCurrentModel('himla'); hoverBrand='himla'" src="../../assets/logos/himla.png" alt="himla logo">
            </div>
            <div class="sub">
                <span v-for="(x, index) in currentModel?.models" :key="index"  @mouseenter="currentCar=x">{{ x.model_name }}</span>
            </div>
        </header>

        <div class="container">
              <!-- car img  -->
              <img loading="lazy" :src="currentCar?.imgURL" alt="car img">

            <!-- <img src="../../assets/chery-cars-png/arrizo/arrizo-5.png" alt="car img"> -->

            <div class="controller" v-if="false">
                <!-- left -->
                <button><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" /></svg></button>
                <!-- right -->
                <button><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6"><path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" /></svg></button>
            </div>
        </div>

        <div class="btns">
            <a class="square" target="_blank" :href="currentCar.catalog">view catalog</a>
            <router-link class="square" to="/services/request-quote" tag="button">request a quote</router-link>
        </div>


    </div>
</template>


<script>
import api from "@/apis.js";
export default {
    data() {
        return {
            currentModel: null,
            currentCar: null,
            hoverBrand: "tiggo",
            allModels: [],
        }
    },
    computed: {
    dynamicBrandImg() {
        const brandName = this.currentModel?.brandName;
        console.log('from computed: ', brandName);
        
        const logos = {
            tiggo: require('@/assets/logos/tiggo.png'),
            arrizo: require('@/assets/logos/arrizo.png'),
            himla: require('@/assets/logos/himla.png')
        };
        return logos[brandName.toLowerCase()];
    }
    },
    methods: {
    fetchingModels() {
        api.get('/models')
        .then(res => {
            this.allModels = res.data;
            this.bindCurrentModel('tiggo');
        })
        .catch(err => console.log(err))
    },
    bindCurrentModel(bname) {
        let x = this.allModels?.find(i => i.brandName.toLowerCase() == bname.toLowerCase());
        // console.log(this.allModels);
        // console.log(bname);
        // console.log(x);
        
        this.currentModel = x;
        this.hoverBrand = bname;
        this.currentCar = x?.models[0];
    },
    downloadCatalog(catalogName) {
        // let url = this.currentCar?.catalog;
        let link = document.createElement('a');
        link.href = this.currentCar?.catalog;
        link.download = `${catalogName} catalog`; // Set the desired filename
        document.body.appendChild(link); // Append the link to the body
        link.click(); // Simulate a click on the link
        document.body.removeChild(link); // Remove the link after the click

    }
    },
    mounted() {
        this.fetchingModels();
    }
}
</script>